import { render, staticRenderFns } from "./BasePublisher.vue?vue&type=template&id=481f9203&"
import script from "./BasePublisher.vue?vue&type=script&lang=js&"
export * from "./BasePublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports